import Navbar from '@/components/sections/Navbar';
import HeroSection from '@/components/sections/HeroSection';
import HistorySection from '@/components/sections/HistorySection';
import ArtistsSection from '@/components/sections/ArtistsSection';
import GenresSection from '@/components/sections/GenresSection';
import MediaSection from '@/components/sections/MediaSection';
import EventsSection from '@/components/sections/EventsSection';
import ResourcesSection from '@/components/sections/ResourcesSection';
import NewsletterSection from '@/components/sections/NewsletterSection';
import Footer from '@/components/sections/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#0a1628]" data-testid="home-page">
      <Navbar />
      <HeroSection />
      <HistorySection />
      <ArtistsSection />
      <GenresSection />
      <MediaSection />
      <EventsSection />
      <ResourcesSection />
      <NewsletterSection />
      <Footer />
    </div>
  );
}
